<template>
  <!-- 用來處理多層 router，參考 https://next.router.vuejs.org/zh/guide/essentials/nested-routes.html#%E5%B5%8C%E5%A5%97%E8%B7%AF%E7%94%B1 -->
  <router-view></router-view>
</template>
